import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAPIUrl, request } from 'shared/services/networking'

import { push } from 'react-router-redux'
import { getWidgetSelector, setSelectedProduct, getApplicationsSelector } from 'shared/pages/Company/module'
import { pushBreadcrumbElement } from 'shared/components/Breadcrumb/module'
import { redirectToApplication } from 'shared/components/Menu/module'

export const GET_PORTAL_COMPONENT_REQUEST = 'PORTAL_COMPONENT/GET_PORTAL_COMPONENT_REQUEST'
export const GET_PORTAL_COMPONENT_SUCCESS = 'PORTAL_COMPONENT/GET_PORTAL_COMPONENT_SUCCESS'
export const GET_PORTAL_COMPONENT_ERROR = 'PORTAL_COMPONENT/GET_PORTAL_COMPONENT_ERROR'

export const HANDLE_OBJECT_CLICK = 'PORTAL_COMPONENT/HANDLE_OBJECT_CLICK'

export function getPortalComponentRequest (companyId) {
  return {
    type: GET_PORTAL_COMPONENT_REQUEST,
    payload: companyId
  }
}

export function getPortalComponentSuccess (portalComponent) {
  return {
    type: GET_PORTAL_COMPONENT_SUCCESS,
    payload: { portalComponent }
  }
}

export function getPortalComponentError (error) {
  return {
    type: GET_PORTAL_COMPONENT_ERROR,
    payload: error
  }
}

export function handleObjectClick (objectSpecificArguments, objectType, objectId, objectName = null, isPortal = false) {
  return {
    type: HANDLE_OBJECT_CLICK,
    payload: {objectSpecificArguments, objectType, objectId, objectName, isPortal}
  }
}

export const getPortalComponentSelector = state => state.portalComponent.portalComponent

export function * getPortalComponent (action) {
  let companyId = action.payload
  const requestConfig = {
    method: 'get',
    url: `${getAPIUrl()}/common/portal-component/?company=${companyId}`
  }
  try {
    const portalComponent = yield call(request, requestConfig)
    yield put(getPortalComponentSuccess(portalComponent))
  } catch (error) {
    yield put(getPortalComponentError(error))
  }
}

export function * handleObjectClickDispatcher (action) {
  const { objectSpecificArguments, objectType, objectId, objectName, isPortal } = action.payload
  switch (objectType) {
    /* When an application family has already been selected and there is a single app belonging
      to this family then it redirects to this app, as well as when only one app is retrieved,
      and this app is of type smart_diagnostic */
    case 'product':
      var appFamilyFilter = objectSpecificArguments.applicationFamilyId
      const applications = yield select(getApplicationsSelector, objectId, appFamilyFilter)
      yield put(pushBreadcrumbElement(objectName, `/application-selection/${objectId || ''}`))
      if (applications.length === 1 &&
        (appFamilyFilter || applications[0].application_type === 'smart_diagnostic')) {
        yield put(redirectToApplication(applications[0].id, applications[0].name, isPortal))
      } else {
        yield put(push(`/application-selection/${objectId || ''}/${appFamilyFilter || ''}`))
      }
      yield put(setSelectedProduct(objectId))
      break
    case 'application family':
      yield put(push(`/product-selection/${objectId || ''}`))
      break
    case 'application':
      yield put(redirectToApplication(objectId, objectName, isPortal))
      break
    case 'widget':
      const widget = yield select(getWidgetSelector, objectId)
      const route = `/portal/${widget.widget_type}/${objectId}/?id=${objectId}`
      yield put(setSelectedProduct(null))
      yield put(pushBreadcrumbElement(objectName, route))
      yield put(push(route))
      break
    default:
      break
  }
}

export function * getPortalComponentSaga () {
  yield takeEvery(GET_PORTAL_COMPONENT_REQUEST, getPortalComponent)
}

export function * handleObjectClickSaga () {
  yield takeEvery(HANDLE_OBJECT_CLICK, handleObjectClickDispatcher)
}

const initialState = {
  isHomepageLoaded: false,
  portalComponent: [],
  error: null
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_PORTAL_COMPONENT_REQUEST:
      return {
        ...state,
        isHomepageLoaded: false,
        error: null
      }
    case GET_PORTAL_COMPONENT_SUCCESS:
      return {
        ...state,
        isHomepageLoaded: true,
        portalComponent: action.payload.portalComponent
      }
    case GET_PORTAL_COMPONENT_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
